import { render, staticRenderFns } from "./IncidentReasonCreateOrUpdate.vue?vue&type=template&id=bbb728e8&"
import script from "./IncidentReasonCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./IncidentReasonCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports